import { type MyuiEditableType } from '@myre/ui-primitive-components';

import {
  AbstractControl,
  Validators,
  type ValidationErrors,
  type ValidatorFn,
} from '@angular/forms';
import { isNil } from 'lodash-es';

import { type MyuiPeriodPickerRange } from './period-picker.interface';

export class MyuiPeriodPickerValidator {
  public static range(
    control: AbstractControl<MyuiEditableType<MyuiPeriodPickerRange>>,
  ): ValidationErrors | null {
    const value = control.value;
    const isRangeSet = !isNil(value?.from) && !isNil(value.to);

    if (!isRangeSet) {
      return { rangeNotSet: true };
    }

    const isRangeConsistent = value.from <= value.to;

    if (!isRangeConsistent) {
      return { rangeNotValid: true };
    }

    return null;
  }

  public static type(hasTypes: boolean): ValidatorFn {
    return (
      control: AbstractControl<MyuiEditableType<string>>,
    ): ValidationErrors | null => {
      if (hasTypes) {
        return Validators.required(control);
      }

      return null;
    };
  }
}
